import { supabase } from '../supabaseClient';

function getNotificationCountRealTime() {}


//* EventNotifications
async function getEventNotificationByCpIdWithPagination( typeIdVariableString, typeId, fromRange, toRange) {
  return await supabase.from(typeIdVariableString === "cpId" ? "EventNotificationsForCp" : "EventNotificationsForFos").select("*, eventId(*)", { count: "exact" }).eq(typeIdVariableString, typeId).order('created_at', { ascending: false }).range(fromRange, toRange);
}

async function updateEventNotification(typeIdVariableString, postBody, eventNotificationId) {
  return await updateQuery(typeIdVariableString === "cpId" ? "EventNotificationsForCp" : "EventNotificationsForFos", postBody).eq("eventNotificationId", eventNotificationId).select("*").maybeSingle();
}

//* LeadNotification
async function getLeadNotificationByCpId_actionWithPagination(typeIdVariableString, typeId, action, fromRange, toRange) {
  let query = supabase.from(typeIdVariableString === "cpId" ? "LeadNotificationsForCp" : "LeadNotificationsForFos").select("*, eventId(*), userId(*), leadId(* , personId(*)), allotmentPaymentId(*, unitId(*, projectId(*)))", { count: "exact" }).eq(typeIdVariableString, typeId);
  if (action && action !== "") {
    query.eq("action", action);
  }
  return await query.order('created_at', { ascending: false }).range(fromRange, toRange);
}

async function updateLeadNotification(typeIdVariableString, postBody, leadNotificationId) {
  return await updateQuery(typeIdVariableString === "cpId" ? "LeadNotificationsForCp" : "LeadNotificationsForFos", postBody).eq("leadNotificationId", leadNotificationId).select("*").maybeSingle();
}

//* FosNotification
async function geFosNotificationByCpId_actionWithPagination(typeIdVariableString, typeId, fromRange, toRange) {
  return await supabase.from("FosNotifications").select("*, fosId(*)", { count: "exact" }).eq(typeIdVariableString, typeId).order('created_at', { ascending: false }).range(fromRange, toRange);
}

async function updateFosNotification(postBody, fosNotificationId) {
  return await updateQuery("FosNotifications", postBody).eq("fosNotificationId", fosNotificationId).select("*").maybeSingle(); 
}

export {
  //* EventNotifications
  getEventNotificationByCpIdWithPagination,
  updateEventNotification,

  //* EventLeadNotification
  getLeadNotificationByCpId_actionWithPagination,
  updateLeadNotification,

  //* FosNotification
  geFosNotificationByCpId_actionWithPagination,
  updateFosNotification,
}

function updateQuery(tableName, postData) {
  let _postBody = { ...postData };
  _postBody.last_updated_at = Date.now();

  return supabase.from(tableName).update(_postBody);
}